import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OnboardingMenu } from 'src/app/enums/enums';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { DocumentStatisticsService } from 'src/app/services/core/document-statistics/document-statistics.service';
import { getDocumentStatisticLabel } from 'src/app/utils/document-statistics-labels.utils';

@Component({
  selector: 'app-expired-documents-modal',
  templateUrl: './expired-documents-modal.component.html',
  styleUrls: ['./expired-documents-modal.component.css']
})
export class ExpiredDocumentsModalComponent implements OnInit {
  @Input() data: any;
  @Output() closeModal = new EventEmitter<void>();

  companyId: any;
  entityType: any;
  documentType: any;
  windowDays: any;
  status: 'expired' | 'willExpire' = 'expired';

  companyName = '';
  documentLabel = '';
  expiredResults: any[] = [];
  willExpireResults: any[] = [];
  expiredGroups: { companyId: string | null; companyName: string | null; items: any[] }[] = [];
  willExpireGroups: { companyId: string | null; companyName: string | null; items: any[] }[] = [];
  loading = false;
  error = false;

  get isAggregate(): boolean {
    return !this.companyId;
  }

  constructor(
    private documentStatisticsService: DocumentStatisticsService,
    private router: Router,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.companyId = this.data?.companyId;
    this.entityType = this.data?.entityType;
    this.documentType = this.data?.documentType;
    this.windowDays = this.data?.windowDays;
    this.status = this.data?.status || 'expired';
    this.companyName = this.data?.companyName || '';
    this.documentLabel = getDocumentStatisticLabel(this.entityType, this.documentType);
    this.getExpiredDocuments();
  }

  getExpiredDocuments() {
    const queryParams: any = {
      company: this.companyId,
      entityType: this.entityType,
      document: this.documentType,
      windowDays: this.windowDays,
    };
    if (!this.companyId) {
      delete queryParams.company;
    }

    this.loading = true;
    this.error = false;
    this.documentStatisticsService
      .getExpiredDocuments(queryParams)
      .subscribe((response: any) => {
        this.loading = false;
        const companies: any[] = response?.data || [];
        if (!this.companyName) {
          this.companyName = companies[0]?.companyName || '';
        }
        this.expiredGroups = companies
          .filter(company => company.expired?.length)
          .map(company => ({
            companyId: company.companyId,
            companyName: company.companyName,
            items: [...company.expired].sort((a, b) => a.daysLeft - b.daysLeft)
          }));
        this.willExpireGroups = companies
          .filter(company => company.willExpire?.length)
          .map(company => ({
            companyId: company.companyId,
            companyName: company.companyName,
            items: [...company.willExpire].sort((a, b) => a.daysLeft - b.daysLeft)
          }));
        this.expiredResults = this.expiredGroups.flatMap(group => group.items);
        this.willExpireResults = this.willExpireGroups.flatMap(group => group.items);
      },
        (error) => {
          this.loading = false;
          this.error = true;
          console.error('Error fetching expired documents:', error);
        }
      );
  }

  onItemClick(item: any, companyId: any) {
    if (!companyId) {
      return;
    }
    let redirect: any;
    if (this.entityType === 'driver') {
      redirect = { entityType: OnboardingMenu.DRIVERS, entity: { ...item, id: item._id, company: companyId, isActive: item.isActive ?? true, documentType: this.documentType, documentStatus: this.status } };
    } else if (this.entityType === 'vehicle') {
      redirect = { entityType: OnboardingMenu.VEHICLES, entity: { ...item, id: item._id, company: companyId, isActive: item.isActive ?? true, documentType: this.documentType, documentStatus: this.status } };
    } else if (this.entityType === 'company') {
      redirect = { entityType: OnboardingMenu.COMPANY, entity: { id: companyId, documentType: this.documentType, documentStatus: this.status } };
    }
    if (!redirect) {
      return;
    }
    this.sharedDataService.onBoardingRedirectForNewTab(redirect);
    const url = this.router.createUrlTree(['/credentials', companyId], {
      fragment: redirect.entityType
    });
    window.open(this.router.serializeUrl(url), '_blank');
    this.sharedDataService.clearOnboardingRedirectFromThisTab();
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
